// src/components/common/useConfirmFreeTextState.js
//
// ConfirmDialog's free-text bookkeeping, extracted to keep ConfirmDialog.js
// under the line cap (zero behaviour change): the live evaluation (with the
// opt-in `requiredHelper` shown after a tap), and the touch keyboard-sized
// height cap — applied only while a keyboard-owning field is actually shown.

import { useState } from 'react';
import { freeTextOwnsKeyboard } from './ConfirmFreeTextField';
import { evaluateConfirmFreeText } from '../../utils/ui/evaluateConfirmFreeText';
import { summonDialogHeightCap } from './keyboardOverlayStyles';

export default function useConfirmFreeTextState({ freeTextInput, inputRequired, trimmed }) {
  const hasFreeText = Boolean(freeTextInput);
  const coarsePointer = typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches;
  const [otherOpen, setOtherOpen] = useState(false);
  const hasPresets = Array.isArray(freeTextInput?.presets);
  const summonHeightCap = (inputRequired || freeTextOwnsKeyboard(freeTextInput, otherOpen)) && coarsePointer
    ? summonDialogHeightCap()
    : null;
  const freeTextEval = hasFreeText
    ? evaluateConfirmFreeText(freeTextInput, trimmed)
    : { ok: true, helper: null, tone: null };
  const freeTextOk = freeTextEval.ok;
  // Opt-in (KAN-1129): keeps the morph button live while the text is missing;
  // a tap shows this helper instead of going dead.
  const requiredHelper = hasFreeText ? freeTextInput.requiredHelper : null;
  const [attempted, setAttempted] = useState(false);
  const shownFreeTextEval = attempted && !freeTextOk && !freeTextEval.helper && requiredHelper
    ? { ok: false, helper: requiredHelper, tone: 'danger' }
    : freeTextEval;
  return {
    hasPresets, setOtherOpen, summonHeightCap, freeTextOk, requiredHelper,
    setAttempted, shownFreeTextEval,
  };
}
